import * as audio from '@/utils/audio';
import {
	GAME_TAB_BUTTON_TEXT,
	GAME_TAB_HEIGHT,
	GAME_TAB_COLOR_SELECTED,
	GAME_TAB_COLOR_UNSELECTED,
	GAME_TAB_BORDER_SELECTED,
	GAME_TAB_BORDER_UNSELECTED,
	GAME_TAB_TEXT_SELECTED,
	GAME_TAB_TEXT_UNSELECTED
} from '@/constants';

/**
 * Componente riutilizzabile per i tab di selezione gioco.
 *
 * @class GameTab
 * @extends Phaser.GameObjects.Container
 */
export default class GameTab extends Phaser.GameObjects.Container {
	/**
	 * Crea un nuovo tab per la selezione del gioco.
	 *
	 * @constructor
	 * @param {Phaser.Scene} scene - La scena che contiene questo componente.
	 * @param {number} x - Coordinata orizzontale.
	 * @param {number} y - Coordinata verticale.
	 * @param {number} width - Larghezza del tab.
	 * @param {string} label - Testo da visualizzare nel tab.
	 * @param {boolean} isSelected - Stato iniziale di selezione.
	 */
	constructor(scene, x, y, width, label, isSelected = false) {
		super(scene, x, y);

		this.scene = scene;
		this.isSelected = isSelected;
		this.label = label;

		// Background del tab
		this.background = scene.add.rectangle(
			0,
			0,
			width,
			GAME_TAB_HEIGHT,
			isSelected ? GAME_TAB_COLOR_SELECTED : GAME_TAB_COLOR_UNSELECTED,
			1
		);
		this.background.setStrokeStyle(
			2,
			isSelected ? GAME_TAB_BORDER_SELECTED : GAME_TAB_BORDER_UNSELECTED
		);

		// Testo del tab
		this.text = scene.add.text(0, 0, label.toUpperCase(), {
			fontSize: GAME_TAB_BUTTON_TEXT,
			fontFamily: 'Luckiest Guy',
			fill: isSelected ? GAME_TAB_TEXT_SELECTED : GAME_TAB_TEXT_UNSELECTED,
			align: 'center'
		}).setOrigin(0.5);

		// Aggiungo gli elementi al container
		this.add(this.background);
		this.add(this.text);

		// Imposto l'area interattiva
		this.setSize(width, GAME_TAB_HEIGHT);
		this.setInteractive({ useHandCursor: true });

		// Suono al click
		this.on('pointerup', function() {
			audio.playSound(scene, 'button-click');
		});

		// Aggiungo il container alla scena
		scene.add.existing(this);
	}

	/**
	 * Imposta lo stato di selezione del tab.
	 *
	 * @param {boolean} selected - true se il tab è selezionato, false altrimenti.
	 * @returns {GameTab} - Ritorna this per il chaining.
	 */
	setSelected(selected) {
		this.isSelected = selected;

		// Aggiorno il background
		this.background.setFillStyle(
			selected ? GAME_TAB_COLOR_SELECTED : GAME_TAB_COLOR_UNSELECTED,
			1
		);
		this.background.setStrokeStyle(
			2,
			selected ? GAME_TAB_BORDER_SELECTED : GAME_TAB_BORDER_UNSELECTED
		);

		// Aggiorno il colore del testo
		this.text.setStyle({
			fill: selected ? GAME_TAB_TEXT_SELECTED : GAME_TAB_TEXT_UNSELECTED
		});

		return this;
	}

	/**
	 * Aggiorna il testo del tab.
	 *
	 * @param {string} newLabel - Nuovo testo da visualizzare.
	 * @returns {GameTab} - Ritorna this per il chaining.
	 */
	setLabel(newLabel) {
		this.label = newLabel;
		this.text.setText(newLabel.toUpperCase());
		return this;
	}
}